import { columnTypes } from "../../../shared/table/columnTypes";
import SmartNumberInput from "../../../shared/form/reactHookForm/SmartNumberInput";

export const getSalesVolumeAndThresholdsColumns = ({
  showPrior30 = true,
  showPrior90 = true,
  showPrior180 = true,
  editedThresholds = {},
  setEditedThresholds = () => {},
} = {}) => {
  const cols = [
    {
      title: "Code",
      dataIndex: "PlateTypeCode",
      type: columnTypes.TEXT,
      width: 35,
      className: "highlightable-cell",
    },
    {
      title: "Plate Type",
      dataIndex: "PlateType",
      type: columnTypes.TEXT,
      width: 195,
      className: "highlightable-cell",
    },
    {
      title: "Qty on Hand",
      dataIndex: "QtyOnHand",
      type: columnTypes.NUMBER,
      width: 45,
      align: "right",
      className: "highlightable-cell",
    },
    {
      title: "Current Threshold",
      dataIndex: "Threshold",
      type: columnTypes.NUMBER,
      width: 60,
      align: "right",
      className: "highlightable-cell",
      render: (value) => value ?? "",
    },
    {
      title: "Below/Above Threshold",
      dataIndex: "AboveThreshold",
      type: columnTypes.NUMBER,
      width: 75,
      align: "right",
      className: "highlightable-cell",
      render: (value) => value ?? "",
    },
    {
      title: "Qty Sold in Date Range",
      dataIndex: "IssuedTotal",
      type: columnTypes.NUMBER,
      width: 60,
      align: "right",
    },
  ];

  if (showPrior180) {
    cols.push({
      title: "Qty Sold Last 180 Days",
      dataIndex: "IssuedPrior3",
      type: columnTypes.NUMBER,
      width: 60,
      align: "right",
    });
  }

  if (showPrior90) {
    cols.push({
      title: "Qty Sold Last 90 Days",
      dataIndex: "IssuedPrior2",
      type: columnTypes.NUMBER,
      width: 60,
      align: "right",
    });
  }

  if (showPrior30) {
    cols.push({
      title: "Qty Sold Last 30 Days",
      dataIndex: "IssuedPrior1",
      type: columnTypes.NUMBER,
      width: 60,
      align: "right",
    });
  }

  cols.push({
    title: "New Threshold",
    dataIndex: "NewThreshold",
    key: "NewThreshold",
    width: 135,
    align: "right",
    fixed: "right",
    render: (_, record) => {
      const value = Object.prototype.hasOwnProperty.call(editedThresholds, record.PlateTypeKey)
        ? editedThresholds[record.PlateTypeKey]
        : record.Threshold ?? null;

      return (
        <SmartNumberInput
          size="small"
          value={value}
          onChange={(val) =>
            setEditedThresholds((prev) => ({
              ...prev,
              [record.PlateTypeKey]: val,
            }))
          }
          min={0}
          max={999}
          step={1}
          precision={0}
          controls={false}
          style={{
            borderColor: "#1677ff",
            backgroundColor: "#e6f4ff",
            textAlign: "right",
            maxWidth: "180px",
          }}
          placeholder="Enter threshold (optional)"
        />
      );
    },
  });

  return cols;
};
